import { getRecentSearches, RecentSearchesResponse } from "common/apis";
import { useQuery } from "@tanstack/react-query";
import { Storage } from "common/storage";

/**
 * Hook to fetch all recent searches at once (with high perPage value)
 * Used for the expanded "All Recent Searches" view
 * @param enabled - Whether to fetch data (only enabled when expanded view is active)
 */
export const useAllRecentSearches = (enabled: boolean = false) => {
  return useQuery<RecentSearchesResponse, Error>({
    queryKey: ["allRecentSearches"],
    queryFn: async () => {
      const token = Storage.getCurrentUserToken() || "";
      return getRecentSearches(token, 1, 100, "recent");
    },
    enabled, // Only fetch when expanded view is active
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 1,
    retryDelay: 1000,
  });
};
